/**
 * useOccupationListScreen.js
 * ---------------------
 * Hook for Occupation Master list screen using shared useMasterList and background JobEngine export.
 */
import { useMasterList } from '../../common/useMasterList';
import * as occupationApi from '../api/occupationApi';
import { useExportJob } from '../../../../hooks/useExportJob';

export function useOccupationListScreen() {
  const master = useMasterList({
    entityName: 'Occupation',
    apiClient: occupationApi.occupationClient,
    fetchList: occupationApi.listOccupations,
    archiveItem: occupationApi.archiveOccupation,
    deleteItem: occupationApi.deleteOccupation,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'occupation',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
